import styled from "@emotion/styled";

import { FullWidthContainer } from "metabase/styled-components/layout/FullWidthContainer";

export const DashboardContainer = styled(FullWidthContainer)`
  margin-top: 0.5rem;
`;
